import ItemLocationDTO from "../../DTO/ItemLocationDTO"
import mainservice from "../../../services/MainService"
import InlineMenu from "../../elements/InlineMenu"
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Stack, TableCell, TableRow } from "@mui/material";
import { Table } from "react-feather";
import InputB from "../../../components/InputB/InputB";

export default function Location(props: {
  item: ItemLocationDTO,
  onClick?: (id: number, item: ItemLocationDTO) => void,
  className?: string,
  onTrash?: () => void,
  noEdit?: boolean,
  withAddress?: boolean,
}) {
  const item = props.item
  return <TableRow className={`STLocation ${props.className || ''}`}>
    <TableCell>
      <Button
        className={`textLeft ${props.withAddress === true ? '' : 'flex-grow'}`}
        onClick={() => {
          if (props.onClick) {
            props.onClick(item.id, item)
            return
          }
          mainservice.navTo([['view', 'spLocationEdit'], ['id', item.id]])
        }}
      >
        {
          props.withAddress === true ?
            <Stack spacing={1} className="flex-grow">
              {item.getArrayAddress().map((i, index) => <Box key={`address-${index}`} style={{fontWeight: index === 0 ? 'bold' : 'normal'}}>{i}</Box>)}
            </Stack>
          :
          <>{item.name}</>
        }
      </Button>  
    </TableCell>
    <TableCell>
      <Stack spacing={2}>
        
        <Box>{item.getPropV1('data', 'phone')||''}</Box>
        <Box><a target="_blank" href={'mailto:'+item.getPropV1('data', 'email1')||''} rel="noreferrer">{item.getPropV1('data', 'email1')||''}</a></Box>
        <Box><a target="_blank" href={item.getPropV1('data', 'url')||''} rel="noreferrer">{item.getPropV1('data', 'url')||''}</a></Box>
        
      </Stack>
    </TableCell>
    <TableCell>
      <Box
        dangerouslySetInnerHTML={{__html: item.getPropV1('data', 'importantShortInformation') || ''}}
      ></Box>
    </TableCell>
    <TableCell align="right">
      <InlineMenu
        title={<MoreVertIcon />}
        options={
          [
            {
              title: 'Bearbeiten',
              icon: <EditIcon />,
              show: !props.noEdit,
              onClick: () => {
                mainservice.navTo([['view', 'spLocationEdit'], ['id', item.id]])
              },
            },
            {
              title: 'Löschen',
              icon: <DeleteIcon />,
              show: !!props.onTrash,
              onClick: props.onTrash,
            }
          ]
        }
      />
    </TableCell>
  </TableRow>
}
